<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [message]="LoadingGenericoMessage" [loadingGenerico]="LoadingGenerico"></app-loading-generico>

<app-alert-erro-customizado [alertErro]="beneficioRepetido" [alertErroMensagem]="mensagemBeneficioRepetido" [alertErroTitulo]="tituloMensagemBeneficioRepetido" [alertErroBotao]="botaoBeneficioRepetido" (alertErroFechou)="fecharAlertPedidoErro()"></app-alert-erro-customizado>

@if (falhaPesquisa) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/error.png" width="82px" alt="erro">
      <p class="titulo-alert mt-4 c-danger"> {{ mensagemErroSubtitulo }} </p>
      <div class="footer-alert bg-danger">
        <p class="subtitulo-alert"> {{ mensagemErro }} </p>
        <button class="btn-borda-branca btn-font-branco btn-grande-vermelho mt-3" (click)="fecharAlertErro()">SAIR</button>
      </div>
    </div>
  </div>
}

<div class="container-fluid py-4" style="width: 1300px">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- BUSCAR PEDIDO PELO NÚMERO DO PEDIDO -->
        <div class="input-group float-end align-items-center w-38">
          <input type="number" class="form-control sombra" id="inptBuscarNumeroPedido" (keydown.enter)="buscarNumeroPedido()" [(ngModel)]="numeroPedidoInput" placeholder="Realize a busca pelo número do pedido">
          <button id="btnBuscarPedido" (click)="buscarNumeroPedido()" class="btn-icon">
            <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
          </button>
        </div>
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Listar Pedidos</h1>
        <p class="paragrafo mb-4">Acompanhamento de pedidos realizados
          @if (numeroPedidoVazio) {
            <span class="float-end legenda-erro me-3">Digite o número do pedido</span>
          }
        </p>

        <!-- FILTRAR PEDIDOS POR DATA - POR ENQUANTO NÃO DA POIS NÃO VEM ESSAS INFORMAÇÕES NA API -->
        @if (empresas) {
          <div class="row mb-4">
            <div class="col-6 col-md-3">
              <div class="mb-4">
                <label class="label-menor" for="inptDtInicialFiltro">Data Inicial</label>
                <input class="form-control" id="inptDtInicialFiltro" dateMask [matDatepicker]="picker" placeholder="dd/mm/aaaa" [(ngModel)]="dataInicial"
                  [ngClass]="{ 'is-invalid': dataInicialError }">
                <mat-datepicker-toggle matSuffix [for]="picker" [ngClass]="{ 'datepicker-error-custom': dataInicialError }" class="datepicker-custom"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                @if (dataInicialVazia) {
                  <p class="legenda-erro mt-1 mb-0">Selecione a data inicial</p>
                }
                <field-error [isError]="dataInicialError && !dataInicialVazia" [message]="dataInicialMessageError"></field-error>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="mb-4">
                <label class="label-menor" for="inptDtFinalFiltro">Data Final</label>
                <input class="form-control" id="inptDtFinalFiltro" dateMask [matDatepicker]="picker1" placeholder="dd/mm/aaaa" [(ngModel)]="dataFinal"
                  [ngClass]="{ 'is-invalid': dataFinalError }">
                <mat-datepicker-toggle matSuffix [for]="picker1" [ngClass]="{ 'datepicker-error-custom': dataFinalError }" class="datepicker-custom"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                @if (dataFinalVazia) {
                  <p class="legenda-erro mt-1 mb-0">Selecione a data final</p>
                }
                <field-error [isError]="dataFinalError && !dataFinalVazia" [message]="dataFinalMessageError"></field-error>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="button-content">
                  <button class="botao-secundario" id="btnFiltrar" (click)="filtrarData()" (click)="onDataFinalPedido()"
                (click)="onDataInicialPedido()" (click)='dataHoje()' [ngClass]="{
                  disabled: !('PedidosListarPedidos' | usuarioPermissao:'Imprimir' | async)
                }" [disabled]="!('PedidosListarPedidos' | usuarioPermissao:'Imprimir' | async)">FILTRAR</button>
                  <button class="botao-outline ms-3" id="btnLimparFiltro" (click)="limparFiltro()">LIMPAR FILTRO</button>
                </div>
              </div>
            </div>
          }

          <!-- TODAS AS EMPRESAS - SEM FILTRO -->
          @if (empresas) {
            <div >
              @for (empresa of empresas | paginate: { id: 'paginacaoEmpresas',
                itemsPerPage: empresasPorPagina,
                currentPage: paginaEmpresa,
                totalItems: totalEmpresas }; track empresa; let i = $index) {
                <div class="row ps-3 pt-3 text-start card-empresa">
                  <button class="coluna-seta" (click)="abreFechaEmpresa(empresa)">
                    <i class="fa fa-chevron-right c-primary icone-abre-fecha" id="flechaResolucao{{empresa.idEmpresa}}" aria-hidden="true"></i>
                  </button>
                  <div class="coluna-cnpj">
                    <p class="info-empresa">{{empresa.cnpj | cnpj}}</p>
                  </div>
                  <div class="coluna-razao-social">
                    <p class="info-empresa">{{empresa.razaoSocial | camelCase}} - {{empresa.nomeFantasia | camelCase}}
                      @if (empresa.pedidos) {
                        <span class="quantidade-pedidos">{{empresa?.pedidos?.length}}</span>
                      }</p>
                    </div>
                    <!-- COLUNA QUE FICA ESCONDIDA E APARECE AO CLICAR NA SETA -->
                    <div class="coluna-resolucao d-none" id="colunaResolucao{{empresa.idEmpresa}}">
                      @if (empresa.carregandoPedidos) {
                        <div>
                          <div class="text-center">
                            <output class="spinner-border c-primary"></output>
                          </div>
                        </div>
                      }
                      <!-- TABELA COM OS PEDIDOS -->
                      @if (empresa.pedidos && empresa.pedidos.length) {
                        <table class="table table-hover table-responsive border-bottom">
                          <caption>Tabela com lista de pedidos</caption>
                          <thead>
                            <tr>
                              <th scope="col" class="border-top-0"></th>
                              <th scope="col" class="border-top-0">PEDIDO</th>
                              <th scope="col" class="border-top-0">EMISSÃO</th>
                              <th scope="col" class="border-top-0">PAGAMENTO</th>
                              <th scope="col" class="border-top-0">ENTREGA</th>
                              <th scope="col" class="border-top-0">VALOR TOTAL</th>
                              <th scope="col" class="border-top-0">FINANCEIRO</th>
                              <th scope="col" class="border-top-0">OPERACIONAL</th>
                              <th scope="col" class="border-top-0">RECARGA CERTA</th>
                              <th scope="col" class="border-top-0">TIPO DO PEDIDO</th>
                              <th scope="col" class="border-top-0">IMPRIMIR BOLETO</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- LINHA 1 -->
                            @for (pedido of empresa.pedidos; track pedido; let i = $index) {
                              <tr>
                                <td class="text-center">
                                  <button class="btn p-0" id="btn{{empresa.idEmpresa}}-{{pedido.idPedido}}" (click)="detalharPedido(pedido.idPedido, empresa.idEmpresa)" data-bs-toggle="tooltip" data-placement="top" title="Clique para detalhar o pedido" [ngClass]="{ disabled: !('PedidosListarPedidos' | usuarioPermissao:'Imprimir' | async) }" [disabled]="!('PedidosListarPedidos' | usuarioPermissao:'Imprimir' | async)">
                                    <i class="fa fa-plus-circle icone" aria-hidden="true"></i>
                                  </button>
                                </td>
                                <td>{{pedido.idPedido}}</td>
                                <td style="width: 128px">
                                {{pedido.dataPedido | appDate: 'dd/MM/yyyy HH:mm'}}</td>
                                <td>{{pedido.dataPagamentoPrevisto | appDate: 'dd/MM/yyyy'}}</td>
                                <td>{{pedido.dataPrevisaoEntrega | appDate: 'dd/MM/yyyy'}}</td>
                                <td class="text-nowrap">{{pedido.valorPedido}}</td>
                                <td><span
                                [ngClass]="{ 'status-pago': pedido.flagStatus == 'Pago', 'status-a-pagar': pedido.flagStatus == 'A Pagar', 'status-liberado': pedido.flagStatus == 'Lib. Produção'}">{{pedido.flagStatus}}</span>
                              </td>
                              <td>{{pedido.flagStatusProcessamento}}</td>
                              <td>{{pedido.descTipoPedido}}</td>
                              <td style="width: 120px">{{pedido.flagFase | camelCase}}</td>
                              <td class="text-center">
                                @if (pedido.flagEmpresaPosPre === 'Pós' && pedido.flagStatus === 'Lib. Produção') {
                                  <button
                                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosListarPedidos?.Imprimir)"
                                    (click)="baixarBoletoPedido(pedido.idPedido)"
                                    class="btn-icon"
                                    >
                                    <i class="fa fa-download c-primary" aria-hidden="true"></i>
                                  </button>
                                }
                                @if (pedido.flagEmpresaPosPre === 'Pré' && pedido.flagStatus !== 'Pago') {
                                  <button
                                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosListarPedidos?.Imprimir)"
                                    (click)="baixarBoletoPedido(pedido.idPedido)"
                                    class="btn-icon"
                                    >
                                    <i class="fa fa-download c-primary" aria-hidden="true"></i>
                                  </button>
                                }
                                @if ((pedido.flagEmpresaPosPre === 'Pós' && pedido.flagStatus !== 'Lib. Produção') || (pedido.flagEmpresaPosPre === 'Pré' && pedido.flagStatus === 'Pago')) {
                                  <span>Indisponível</span>
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                    <!-- ERRO AO CONSULTAR PEDIDOS -->
                    @if (empresa.pedidos === false) {
                      <div class="text-center">
                        <img src="/assets/img/erro.png" alt="representando erro na consulta de pedidos" width="230px">
                        <p class="legenda-erro">Ocorreu um erro na consulta dos pedidos. Recarregue a página ou tente novamente
                        mais tarde.</p>
                      </div>
                    }
                    <!-- EMPRESA NÃO POSSUI PEDIDOS -->
                    @if (empresa.pedidos?.length == 0) {
                      <div class="text-center">
                        <img src="/assets/img/vazio.png" alt="representando que não existem pedidos relacionados a este cnpj" width="230px">
                        <p class="legenda-vazio">Não existem pedidos relacionados a este CNPJ.</p>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

        <!-- CASO DE ERRO EMPRESAS SEM REGISTROS-->
        @if (empresaSemRegistrosError) {
        <div class="text-center">
          <img src="/assets/img/vazio.png" alt="representando que não foram encontrados registros" width="230px">
          <p class="legenda-vazio">Nenhum registro encontrado</p>
        </div>
        }

          <!-- BOTÕES BAIXAR -->
          @if (empresas) {
            <div class="row text-center">
          <button class="botao-erro-outline mx-auto mt-4 ajuste-botao" routerLink="/cancelar-pedidos" [ngClass]="{
              disabled: !('PedidosListarPedidos' | usuarioPermissao:'Excluir' | async)
            }" [disabled]="!('PedidosListarPedidos' | usuarioPermissao:'Excluir' | async)">CANCELAMENTO DE
              PEDIDOS</button>
              @if (temBoleto) {
<button class="botao mt-4 mx-auto ajuste-botao" (click)="startFileGeneration()" [ngClass]="{
              disabled: !('PedidosListarPedidos' | usuarioPermissao:'Imprimir' | async)
            }" [disabled]="!('PedidosListarPedidos' | usuarioPermissao:'Imprimir' | async)">BAIXAR TODOS OS BOLETOS
                </button>
              }
            </div>
          }

          <!-- CARREGAMENTO EMPRESAS -->
          @if (!empresas || empresas === null) {
            <div>
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando dados sobre pedidos ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando dados sobre pedidos ...</p>
            </div>
          }

          <!-- CASO DE ERRO EMPRESAS -->
          @if (empresas === false) {
            <div class="text-center">
              <img src="/assets/img/erro.png" alt="representando erro na consulta de lista de pedidos" width="230px">
              <p class="legenda-erro">Ocorreu um erro na consulta da lista de pedidos.</p>
            </div>
          }

          <!-- FOOTER-CARD - PAGINAÇÃO - EMPRESAS -->
          @if (empresas) {
            <div class="footer-card">
              <div>
                <app-select
                  [value]="empresasPorPagina"
                  (valueChanges)="onPageSizeChange($event)"
                  name="empresasPorPaginaName"
            [options]="[
            {name : 'Exibir 5 Empresas' , value : '5'} ,
            {name : 'Exibir 10 Empresas' , value : '10'},
            {name : 'Exibir 15 Empresas' , value : '15'},
            {name : 'Exibir 20 Empresas' , value : '20'},
            {name : 'Exibir 100  Empresas' , value : '100'}
            ]"
                  optionValue="value"
                  optionText="name">
                </app-select>
              </div>
              <!-- Paginação CENTRAL -->
              <div>
                <pagination-controls class="my-pagination" id="paginacaoEmpresas" directionLink="true"
                  (pageChange)="onPageChange($event)" responsive="true" previousLabel="Anterior" nextLabel="Próxima">
                </pagination-controls>
              </div>
              <div>
                @if (empresas.length == 1) {
                  <p><span class="itens-pagina">{{empresas.length}}</span> Empresa foi encontrada
                </p>
              }
              @if (empresas.length > 1) {
                <p><span class="itens-pagina">{{empresas.length}}</span> Empresas foram
              encontradas</p>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
</div>

<app-footer></app-footer>
